// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e816285e","239":"04b2ded6","453":"13374cf9","455":"03529191"}[chunkId] + ".chunk.js";
};